import ImageCaptureStore from "../stores/ImageCaptureStore";    
const VPID_NOT_FOUND_ERROR = "Vision Program ID not found";
const PHOTO_CAPTURE_FAILED_ERROR = "Failed to capture image from Snappi";

export const captureImageSnappi = async (
    visionProgramId: string,
    shouldCaptureUnblurred: boolean,
    imageCaptureStore: ImageCaptureStore
): Promise<void> => {
    const vpid = Number(visionProgramId);

    if (Number.isNaN(vpid)) {
        imageCaptureStore.setError("Invalid Vision Program ID");
        return;
    }

    imageCaptureStore.setLoading(true);

    try {
        const takePhotoUrl = `https://snappi.vivacitylabs.com/snappi/${vpid}?blur=${!shouldCaptureUnblurred}`;

        const response = await fetch(takePhotoUrl, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${imageCaptureStore.jwt}`,
            },
        });

        if (response.status === 404) {
            imageCaptureStore.setError(VPID_NOT_FOUND_ERROR);
            console.warn(VPID_NOT_FOUND_ERROR);
            return;
        }

        if (!response.ok) {
            const errMsg = `${PHOTO_CAPTURE_FAILED_ERROR}: ${response.status} ${response.statusText}`;
            imageCaptureStore.setError(errMsg);
            console.error(errMsg);
            return;
        }

        const arrayBuffer = await response.arrayBuffer();
        const bytes = new Uint8Array(arrayBuffer);

        imageCaptureStore.setImageBytes(bytes);
    } catch (error) {
        const message = error instanceof Error ? error.message : "Unknown error";
        imageCaptureStore.setError(message);
        console.error("Snapshot error:", message);
    } finally {
        imageCaptureStore.setLoading(false);
    }
};
